<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false" on-slide-changed="slideChange($index)">
      <slide>
        <div class="padding">
          <p>The geography of Portus seems to change, seems to shift from day to day. I picked Oska up from school today, we took our normal route home but suddenly found ourselves stood outside the zone staring back in. The turning we walked down, a gap between two tall structures i didn't recognise promised a shortcut to the market and gave up a winding route that only led down under the plustens toward the river and the perolink.</p>
          <p>Oska held my hand throughout the journey, as if he knew something wasn't right. </p>
          <br>
          <p>The road sloped away from us, steps led further down and then everything stopped. The stone changed, became darker and stepped in steeper increments, a railing to our left ceased to stand and we stood at the bottom of a hill that should not have been there, and I swear was not here the day before. </p>
          <p>Stretched out in front of us was the river, speckled with light and late morning rain, in the sky sat a single black cloud, hanging like a cloth. In this part of the city the perolinks are made from wood and stone, in contrast to the rusted metal flights from the southern bank. Underneath one though, almost equidistant with the span of the link was a whirlpool. Water swirling around in a clockwise spiral, down into the bed of the river. We joined the citizens on the banks and stared and wondered. </p>
          <p>Then someone stepped out on the link and walked toward the centre. A man, carrying a long pole, like a funerary attendant. He reached the middle and leaned over the side. For a moment, the crowd gathered on the shore, us among them, drew in their breath and held it there. </p>
          <p>He leaned over the side, exactly, so it appeared, at the centre point of the whirlpool, and held the pole out over the side, perfectly perpendicular to the swirling water below him. </p>
         <br>
         <p>Then he dropped it. </p>
         <br>
          <p>For a moment more, we held our breath, and then let it out in a rush. The pole descended into the middle of the rushing water and was swallowed by the whirlpool. Its bearer bowed to the water and waited.</p>
          <p>The water rushed on, and then the first scream sounded. </p>
         <br>
         <p>Oska and i turned, as the crowd did, and saw a wall behind us. A building carved from pale stone barred our way back to the city. It had not been there when we walked down the steps. More screams sounded out. </p>
         <br>
 <p>Ahead, the water churned.</p>
          <br>
<p>Behind, the bells began to ring. </p>
          <br>
<p>We were dragged by the crowd as they pushed over each other toward the shore. </p>
          <br>
<p>I grabbed tight hold of his hand and pulled Oska against the flow, away from the shoreline. I took hold of his hand and made him look away.</p>
          <br>
<p>We turned to the left and ran along the harbour wall, forcing our way through legs and shoulders alike and then he cried out and I held him and I crouched down and told him to shut his eyes. </p>
          <br>
<p>We waited. </p>
          <br>
<p>I felt angry feet kick my back and i heard curses and invoked gods. </p>
          <br>
<p>And we waited and I held him. </p>
         <br>
 <p>His arms were limp and he said nothing, just buried his face into my throat. </p>
         <br>
 <p>And then we opened our eyes. </p>
          <p></p>
          <p> &nbsp;</p>
          <p> &nbsp;</p>
        </div>
      </slide>

    </carousel>
  </div>
</template>

<script>
export default {

  name: '2',

  data () {
    return {
      title: 'Karst Landscapes'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
